module.exports = __webpack_public_path__ + "img/menu-on_02.f3087904.png";